import React, { useState } from 'react';
import IncidentActionPlan from './widgets/IncidentActionPlan';
import InitialIncidentBriefing from './widgets/InitialIncidentBriefing';
import StylishNewSelect from 'components/DesignSystems/New/StylishNewSelect';
import {
  OperationalPeriod,
  usePeriods,
} from 'components/IAP/hooks/incidentHooks';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import IncidentStatusSummary from './widgets/IncidentStatusSummary/IncidentStatusSummary';
import { UseQueryResult } from '@tanstack/react-query';
import AssignmentList from './widgets/AssignmentList/AssignmentList';

export const CurrentIAPView: React.FC = () => {
  const { data: periods }: UseQueryResult<OperationalPeriod[], Error> =
    usePeriods();

  type OptionType = {
    value: number | undefined;
    label: string;
  };

  const sortedOptions: OptionType[] =
    periods
      ?.filter((period) => period.period_number !== 0)
      .map((period) => ({
        value: period.period_number,
        label: `Operational Period ${period.period_number}`,
      }))
      .sort((a, b) => {
        const aValue = a.value ?? 0;
        const bValue = b.value ?? 0;
        return aValue - bValue;
      }) || [];

  const [displayPeriod, setDisplayPeriod] = useState<OptionType | null>(
    sortedOptions ? sortedOptions[sortedOptions.length - 1] : null
  );
  const [currPeriod, setCurrPeriod] = useState<OperationalPeriod | undefined>(
    periods ? periods[periods.length - 1] : undefined
  );
  const currPeriodNumber = currPeriod?.period_number || 0;

  const handleChange = (newValue: OptionType | null) => {
    setDisplayPeriod(newValue);
    const selected = periods?.find(
      (period) => period.period_number === newValue?.value
    );
    setCurrPeriod(selected);
  };

  return (
    <div className="ps-3">
      <div className="d-flex justify-content-start align-items-center gap-2 p-3">
        <SharedIcon iconName="access_time" />
        <span>Operational Period: </span>
        <StylishNewSelect
          options={sortedOptions}
          value={displayPeriod}
          onChange={handleChange}
        />
      </div>
      <div className="planning-container">
        <div>
          {currPeriodNumber <= 1 ? (
            <InitialIncidentBriefing />
          ) : (
            <>
              <IncidentActionPlan currPeriod={currPeriod} />
              <AssignmentList periodNumber={currPeriodNumber} />
              <IncidentStatusSummary currPeriod={currPeriod} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
